module.exports = __webpack_public_path__ + "img/shopping.84569956.jpg";